<template>
    <div>
        <el-page-header @back="goBack" content="特属专家详情"></el-page-header>
        <div class="docker-detail-header" v-if="role_id != 2">
            <el-button type="success" @click="edit">编辑</el-button>
            <el-button type="primary" @click="importinfo">导出资料</el-button>
        </div>
        <Box style="margin-top: 20px;">
            <template #body>
                <table class="table" v-if="!is_mobile">
                    <tbody>
                    <tr>
                        <td class="dockert_img_td" rowspan="6">
                            <el-image :src="user_avatar"></el-image>
                        </td>
                        <td class="docker_title_td">特属专家姓名</td>
                        <td class="docker_value_td">{{ user_name }}</td>
                        <td class="docker_title_td">状态</td>
                        <td class="docker_value_td">{{ status == "1" ? "启用" : "停用" }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">职称</td>
                        <td class="docker_value_td">{{ doctor_title_name }}</td>
                        <td class="docker_title_td">身份证号</td>
                        <td class="docker_value_td">{{ idcard }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">单位</td>
                        <td class="docker_value_td">{{ hospital_nick_name }}</td>
                        <td class="docker_title_td">手机号码</td>
                        <td class="docker_value_td">{{ mobile }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">签约特属服务对象上限</td>
                        <td class="docker_value_td">{{ max_client }}</td>
                        <td class="docker_title_td">所属科室</td>
                        <td class="docker_value_td">{{ hospital_department_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">简介</td>
                        <td class="docker_value_td">{{ introduction }}</td>
                        <td class="docker_title_td">签约时间</td>
                        <td class="docker_value_td">{{ start_date }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">特属服务专员</td>
                        <td class="docker_value_td" colspan="3">{{ admin_user_name }}</td>
                    </tr>
                    </tbody>
                </table>
                <table class="table" v-else>
                    <tbody>

                    <tr>
                        <td class="dockert_img_td" colspan="2" style="width: 100% !important;min-width: 100px;">
                            <el-image :src="user_avatar" style="float: left;"></el-image>
                        </td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">特属专家姓名</td>
                        <td class="docker_value_td">{{ user_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">状态</td>
                        <td class="docker_value_td">{{ status == "1" ? "启用" : "停用" }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">职称</td>
                        <td class="docker_value_td">{{ doctor_title_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">身份证号</td>
                        <td class="docker_value_td">{{ idcard }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">单位</td>
                        <td class="docker_value_td">{{ hospital_nick_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">手机号码</td>
                        <td class="docker_value_td">{{ mobile }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">签约特属服务对象上限</td>
                        <td class="docker_value_td">{{ max_client }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">所属科室</td>
                        <td class="docker_value_td">{{ hospital_department_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">简介</td>
                        <td class="docker_value_td">{{ introduction }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">签约时间</td>
                        <td class="docker_value_td">{{ start_date }}</td>
                    </tr>
                    <tr v-if="role_id != 2 && child_role_id == 0">
                        <td class="docker_title_td">特属服务专员</td>
                        <td class="docker_value_td">{{ admin_user_name }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">特属服务专员电话</td>
                        <td class="docker_value_td">{{ admin_user_mobile }}</td>
                    </tr>
                    </tbody>
                </table>
            </template>
        </Box>

        <div id="statistics_box" class="message_box">
            <p class="message_title">特属专家统计信息</p>
            <table class="table">
                <tbody>
                <tr>
                    <td v-if="role_id == 1">当前签约生效特属服务对象总数</td>
                    <td v-if="role_id != 1">当前签约特属服务对象总数</td>
                    <td>历史签约特属服务对象总数</td>
                    <td v-if="role_id == 1">签约到期特属服务对象总数</td>
                    <td v-if="role_id == 1">签约待生效特属服务对象总数</td>
                    <td>预约处理数量</td>
                    <td>会面中断数量</td>
                    <td>会面完成数量</td>
                </tr>
                <tr>
                    <td>{{ clienting_number }}</td>
                    <td>{{ log_client_number }}</td>
                    <td v-if="role_id == 1">{{ expired_number }}</td>
                    <td v-if="role_id == 1">{{ will_number }}</td>
                    <td>{{ reservationing_number }}</td>
                    <td>{{ reservation_interrupt_number }}</td>
                    <td>{{ reservationed_number }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="table_message_box" v-if="role_id != 1 && role_id != 3 && role_id != 21">
            <p style="float: left">已签特属服务对象列表</p>
            <span style="float: right;">
                <el-date-picker
                    style="height: 40px;line-height: 40px;"
                    @change="doctorUsersList"
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="签约日期"
                    end-placeholder="签约日期"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </span>
            <el-table ref="multipleTable"
                      :data="doctorUsers"
                      border
                      style="width: 100%">
                <el-table-column width="50px" prop="no" label="序号" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="user_name" label="特属服务对象姓名" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="mobile" label="联系电话" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="start_date" label="特属服务对象签约时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="expired_date" label="协议到期时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column label="状态" align="center" label-class-name="label">
                    <template slot-scope="scope">
                        {{ scope.row.status }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
                >
                    <el-button @click="goUserDetail(scope.row)" type="text"
                               size="small">
                        详情
                    </el-button>
                </el-table-column>
            </el-table>
            <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5,10, 25, 50, 100]"
                :total="user_total"
                :page-size="user_perpage"
                :current-page="user_page"
                @current-change="userChangePage"
                @size-change="userChangeSite"
            ></el-pagination>
        </div>
        <div class="table_message_box" v-if="role_id == 1 || role_id == 3 || role_id == 21">
            <p style="float: left">已签特属服务对象列表</p>
            <span style="float: right;margin-left: 5px">
				<el-button type="primary" @click="importUserInfo">导出健康管理健对象资料</el-button>
			</span>
            <span style="float: right;">
                <el-date-picker
                    style="height: 40px;line-height: 40px;"
                    @change="doctorUsersList"
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="签约日期"
                    end-placeholder="签约日期"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </span>
            <el-table ref="multipleTable"
                      :data="doctorUsers"
                      border
                      style="width: 100%">
                <el-table-column width="50px" prop="no" label="序号" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="90px" prop="user_name" label="特属服务对象姓名" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="110px" prop="mobile" label="联系电话" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="80px" prop="reservation_num" label="总预约数" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="100px" prop="reservation_month_num" label="本月预约数" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="80px" prop="meet_num" label="总会面数" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="100px" prop="meet_month_num" label="本月会面数" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="80px" prop="healthrecord_num" label="建立健康档案数量" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="100px" prop="meet_time" label="最近一次会面时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="100px" prop="healthrecord_update_time" label="健康档案最新更新时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="110px" prop="start_date" label="特属服务对象签约时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="110px" prop="expired_date" label="协议到期时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="110px" prop="expired_txt" label="到期状态" align="center" label-class-name="label"
                                 v-if="role_id == 1">
                </el-table-column>
                <el-table-column width="80px" prop="relation_id" label="聊天关系" align="center" label-class-name="label"
                                 v-if="role_id == 1">
                    <template slot-scope="scope">
                        {{ scope.row.relation_id ? '已建立' : '未建立' }}
                    </template>
                </el-table-column>
                <el-table-column width="80px" label="状态" align="center" label-class-name="label">
                    <template slot-scope="scope" v-if="role_id == 1">
                        <span v-if="role_id == 1">{{ scope.row.is_unbind == 1 ? '已解约' : scope.row.status }}</span>
                        <span v-else>{{ scope.row.status }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
                >
                    <el-button @click="goUserDetail(scope.row)" type="text"
                               size="small">
                        详情
                    </el-button>
                    <el-button @click="editChatRelation(scope.row, 'unbind')" type="text" size="small"
                               v-if="role_id==1 && scope.row.relation_id">
                        解除聊天关系
                    </el-button>
                    <el-button @click="editChatRelation(scope.row, 'create')" type="text" size="small"
                               v-if="role_id==1 && !scope.row.relation_id">
                        建立聊天关系
                    </el-button>
                    <el-button @click="resetExpired(scope.row)" type="text" size="small" v-if="role_id == 1">
                        到期状态修复
                    </el-button>
                </el-table-column>
            </el-table>
            <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5,10, 25, 50, 100]"
                :total="user_total"
                :page-size="user_perpage"
                :current-page="user_page"
                @current-change="userChangePage"
                @size-change="userChangeSite"
            ></el-pagination>
        </div>
        <div class="table_message_box">
            <p style="float: left">预约信息记录</p>
            <div class="search_data">
                <el-input @change="searchReservation" v-model="search_reservation_data" placeholder="搜索"/>
            </div>
            <el-table ref="multipleTable"
                      :data="reservationListing"
                      border
                      style="width: 100%">
                <el-table-column width="50px" prop="no" label="序号" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="reservation_id" label="预约编号" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="120px" prop="user_name" label="特属服务对象" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="mobile" label="特属服务对象联系电话" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="120px" prop="doctor_name" label="特属专家" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="doctor_mobile" label="特属专家联系电话" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="120px" prop="status" label="预约状态" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column width="160px" prop="book_date" label="预约会面时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center"
                                 label-class-name="label"></el-table-column>
            </el-table>
            <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5,10, 25, 50, 100]"
                :total="service_total"
                :page-size="service_perpage"
                :current-page="service_page"
                @current-change="serviceChangePage"
                @size-change="serviceChangeSite"
            ></el-pagination>
            <span>
                <el-button @click="goReservationListing">查看更多预约信息</el-button>
            </span>
        </div>


        <el-dialog title="协议详情" :visible.sync="dialogContractFormVisible">
            <el-carousel indicator-position="outside" height="500px" :autoplay="false">
                <el-carousel-item v-for="url in allContractUrls" :key="url">
                    <div class="image_box">
                        <pdf :src="url" v-if="getFileType(url) == 'pdf'"></pdf>
                        <el-image :src="url" v-else></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>

    </div>
</template>
<script>
import env from "@/api/env";
import Box from "@/components/Box.vue";
import {check} from "@/utils/checkData";
import {Loading} from 'element-ui';
import {base64Parser, fileType, getBase64Image, isMobile, loadFile} from "@/api/order";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import {saveAs} from "file-saver";
import ImageModule from "docxtemplater-image-module-free";
import pdf from "vue-pdf";
import {getUserInfos} from "@/utils/userInfos";


export default {
    components: {
        Box,
        pdf
    },
    data() {
        return {
            role_id: 0,
            child_role_id: 0,
            admin_user_name: '',
            admin_user_mobile: '',
            dialogFormVisible: false,
            bindDialogFormVisible: false,
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            search_expired_date: [],
            dialog_title: this.contract_type == 1 ? '新增签约' : '新增续约',
            bind_title: '新增绑定',
            upload_disabled: false,
            user_id: '',
            isShowAddReservationData: 1,
            isShowBindManagerData: 1,
            fileList: [],
            addFileList: [],
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
            search_reservation_data: '',
            user_avatar: '',
            user_name: '',
            status: '',
            doctor_title_name: '',
            idcard: '',
            hospital_name: '',
            hospital_nick_name: '',
            mobile: '',
            introduction: '',
            expired_date: '',
            max_client: '',
            hospital_department_name: '',
            clienting_number: 0, // 签约生效中特属服务对象数
            expired_number: 0,  // 签约到期特属服务对象数
            will_number: 0,  // 签约待生效特属服务对象数
            log_client_number: 0,  // 历史签约特属服务对象总数
            reservationing_number: 0,
            reservation_interrupt_number: 0,
            reservationed_number: 0,
            allCustomer: [],
            doctorUsers: [],
            allContract: [],
            manager_list: [],
            unbind_manager: [],
            allContractUrls: [],
            dialogContractFormVisible: false,
            reservationListing: [],
            service_total: 0,
            service_perpage: 5,
            service_page: 1,
            user_total: 0,
            user_perpage: 5,
            user_page: 1,
            isReadOnly: false,
            contract_type: '',
            managerForm: {
                manager_id: '',
            },
            ruleForm: {
                contract_id: '',
                year: '',
                start_date: '',
                status: 2,
                file: "",
            },
            rules: {
                file: [{required: true, message: "请上传协议", trigger: "blur"}],
                year: [
                    {required: true, message: "请选择年限", trigger: "blur"},
                ],
                start_date: [
                    {required: true, message: "请选择签约日期", trigger: "blur"},
                ],
            },
            allYear: [
                {
                    id: 1,
                    name: '一年'
                },
                {
                    id: 2,
                    name: '二年'
                },
                {
                    id: 3,
                    name: '三年'
                }
            ],
            formLabelWidth: '120px',
            is_submit: false,
            start_date: '',
            is_mobile: false,
        };
    },
    created() {
        localStorage.setItem('prev_page', 'doctor_detail')
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
            this.child_role_id = parseInt(userInfo.child_role_id)
        }
        this.user_id = this.$route.params.user_id || this.$route.query.user_id;
        this.doctorDetail();
        this.reservationListingMethod();
        // this.myManagerList();
        this.doctorUsersList()

    },
    mounted() {
        if (isMobile()) {
            this.is_mobile = true
        }
    },
    methods: {
        getFileType(url) {
            return fileType(url)
        },
        // 获取医生详情资料
        doctorDetail() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'editDetail',
                params: {
                    user_id: this.user_id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                let doctor_detail = res.data.data.doctor_detail;
                if (doctor_detail.user_avatar) {
                    this.user_avatar = this.imgUrl + doctor_detail.user_avatar;
                }
                this.user_name = doctor_detail.user_name;
                this.status = doctor_detail.status;
                this.doctor_title_name = doctor_detail.doctor_title_name;
                this.idcard = doctor_detail.idcard;
                this.hospital_name = doctor_detail.hospital_name;
                this.hospital_nick_name = doctor_detail.hospital_nick_name;
                this.mobile = doctor_detail.mobile;
                this.introduction = doctor_detail.introduction;
                this.expired_date = doctor_detail.expired_date;
                this.max_client = doctor_detail.max_client;
                this.admin_user_name = doctor_detail.admin_user_name;
                this.admin_user_mobile = doctor_detail.admin_user_mobile;
                this.start_date = doctor_detail.start_date;

                this.hospital_department_name = doctor_detail.department_name;
                this.log_client_number = res.data.data.log_client_number;
                if (this.role_id == 1) {
                    this.expired_number = doctor_detail.expired_number;
                    this.will_number = doctor_detail.will_number;
                    // this.clienting_number = doctor_detail.number - doctor_detail.expired_number - doctor_detail.will_number;
                    this.clienting_number = doctor_detail.effective_number;

                } else {
                    this.clienting_number = doctor_detail.number;
                }
                this.reservationing_number = res.data.data.reservationing_number;
                this.reservation_interrupt_number = res.data.data.reservation_interrupt_number;
                this.reservationed_number = res.data.data.reservationed_number;

                for (var i = 0; i < res.data.data.doctor_contract_list.length; i++) {
                    // 以序号代替ID
                    res.data.data.doctor_contract_list[i].no = i + 1
                    switch (res.data.data.doctor_contract_list[i].status) {
                        case '1':
                            res.data.data.doctor_contract_list[i].status = '未确认';
                            break;
                        case '2':
                            res.data.data.doctor_contract_list[i].status = '已确认';
                            break;
                    }
                }

                this.allContract = res.data.data.doctor_contract_list;
            });
        },

        // 预约信息列表
        reservationListingMethod() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'reservationListing',
                params: {
                    user_id: this.user_id,
                    search_reservation_data: this.search_reservation_data,
                },
                pageinfo: {
                    page: this.service_page,
                    perpage: this.service_perpage,
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }

                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 以序号代替ID
                    res.data.data.list[i].no = (this.service_page - 1) * this.service_perpage + i + 1
                    switch (res.data.data.list[i].status) {
                        case '1':
                            res.data.data.list[i].status = '预约处理';
                            break;
                        case '2':
                            res.data.data.list[i].status = '等待会面';
                            break;
                        case '3':
                            res.data.data.list[i].status = '会面完成';
                            break;
                        case '4':
                            res.data.data.list[i].status = '会面中断';
                            break;
                    }
                }

                this.reservationListing = res.data.data.list;
                this.service_total = res.data.data.page.count;
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        // 签约特属服务对象列表
        doctorUsersList() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let start_date = '';
            let end_date = '';

            if (this.search_expired_date) {
                start_date = this.search_expired_date[0]
                end_date = this.search_expired_date[1]
            }
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'doctorUsers',
                params: {
                    user_id: this.user_id,
                    start_start_date: start_date,
                    end_start_date: end_date,
                },
                pageinfo: {
                    page: this.user_page,
                    perpage: this.user_perpage,
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }

                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 以序号代替ID
                    res.data.data.list[i].no = (this.service_page - 1) * this.service_perpage + i + 1
                    res.data.data.list[i].status = (res.data.data.list[i].status == 1) ? "启用" : "停用";
                }
                this.doctorUsers = res.data.data.list;
                this.user_total = res.data.data.page.count;
                this.is_submit = false;
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
            this.is_submit = false;

        },
        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;
        },

        serviceChangePage(index) {
            this.service_page = index;
            this.reservationListingMethod();
        },

        serviceChangeSite(index) {
            this.service_perpage = index;
            this.reservationListingMethod();
        },

        // 跳转编辑
        edit() {
            this.$router.replace({
                name: "doctorEdit",
                params: {
                    user_id: this.user_id
                }
            });
        },

        // 搜索预约信息
        searchReservation() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.service_page = 1;
            this.reservationListingMethod();
        },

        // 查看更多预约
        goReservationListing() {
            this.$router.push({name: "workList", params: {doctor_name: this.user_name}});
        },

        // 添加协议
        addContract() {
            let type = 1;
            if (this.allContract.length > 0) {
                type = 2
                this.dialog_title = '新增续约';
            } else {
                type = 1;
                this.dialog_title = '新增签约';
            }

            this.ruleForm.file = '';
            this.fileList = [];
            this.addFileList = [];
            this.ruleForm.year = '';
            this.ruleForm.start_date = '';
            this.ruleForm.contract_id = '';
            this.isReadOnly = false;
            this.contract_type = type;
            this.$nextTick(() => {
                if (this.allContract == null || this.allContract.length == 0) {
                    this.ruleForm.status = 2;
                    this.isReadOnly = true;
                }
                this.dialogFormVisible = true;
                this.upload_disabled = false;
                this.isShowAddReservationData = 1;
            })
        },

        // 调用接口，添加协议
        addContractData() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    let params = {
                        servername: 'Ruyi_AdminExpertServices',
                        method: this.ruleForm.contract_id != '' ? 'editContract' : 'addContract',
                        params: {
                            id: this.ruleForm.contract_id,
                            user_id: this.user_id,
                            contract_file: this.addFileList,
                            year: this.ruleForm.year,
                            start_date: this.ruleForm.start_date,
                            status: this.ruleForm.status,
                            contract_type: this.contract_type,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: this.ruleForm.contract_id != '' ? '编辑成功' : '新增成功',
                            duration: 1500
                        });
                        this.dialogFormVisible = false;
                        this.doctorDetail();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }
                this.is_submit = false;
            })
        },

        // 点击图片
        handlePreview(file) {

        },

        // 除去图片
        handleRemove(file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        let obj = {
                            file: name,
                            x: fileList[i].x,
                            y: fileList[i].y,
                        };
                        addFileList.push(obj);
                    }
                }
            }
            this.addFileList = addFileList;
            this.ruleForm.file = "";
        },

        // 上传图片成功
        handleSuccess(response, file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        let obj = {
                            file: name,
                            x: fileList[i].x,
                            y: fileList[i].y,
                        };
                        addFileList.push(obj);
                    }
                }
            }
            this.addFileList = addFileList;
            this.ruleForm.file = "file";
        },

        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png/pdf格式!');

            }
            if (!isLt5M) {
                isJPG = false;
                this.$message.error('图片大小不能超过5MB!');

            }
            return isJPG;
        },

        // 协议详情
        oneContractDetail(data, type) {

            if (type == 2) {
                this.upload_disabled = true;
                this.isShowAddReservationData = 0;
            } else {
                this.upload_disabled = false;
                this.isShowAddReservationData = 1;
            }

            this.fileList = [];
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
            }
            this.ruleForm.year = '';
            this.ruleForm.start_date = '';


            let loadingInstance = Loading.service({fullscreen: true});
            this.$nextTick(() => {
                var allFile = [];
                this.addFileList = [];
                if (data.contract_file && data.contract_file != '' && data.contract_file != null) {
                    var contract_file = JSON.parse(data.contract_file);
                    if (contract_file.length > 0) {
                        // this.addFileList = contract_file;

                        for (var i = 0; i < contract_file.length; i++) {
                            let index = contract_file[i].file.lastIndexOf("/");
                            let name = contract_file[i].file.substring(index + 1, contract_file[i].file.length);
                            let oneContract = {
                                name: name,
                                url: this.imgUrl + contract_file[i].file,
                                x: contract_file[i].x,
                                y: contract_file[i].y,
                            };
                            this.addFileList.push({
                                name: name,
                                file: contract_file[i].file,
                            });
                            this.ruleForm.file = "file";
                            allFile.push(oneContract);

                        }
                    }
                }

                this.fileList = allFile;

                this.dialog_title = '签约详情';
                this.ruleForm.year = parseInt(data.year);
                this.ruleForm.start_date = data.start_date;
                this.ruleForm.contract_id = data.id;
            });

            this.$nextTick(() => {
                setTimeout(() => {
                    loadingInstance.close();
                    this.dialogFormVisible = true;
                }, 1000);
            })

        },
        // 删除签约
        oneContractDelete(data) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$confirm('确定删除该协议吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                let params = {
                    servername: 'Ruyi_AdminExpertServices',
                    method: 'deleteContract',
                    params: {
                        id: data.id,
                    }
                };

                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }

                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                            duration: 1500,
                        });
                    } else {
                        this.$message({
                            type: "success",
                            message: '删除成功',
                            duration: 1500,
                        });
                    }
                    this.doctorDetail();
                    this.reservationListingMethod();
                    // this.myManagerList();
                    this.doctorUsersList()
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 协议详情-预览
        oneReservationDetail(data) {

            this.allContractUrls = [];
            var allContractUrls = [];
            if (data.contract_file) {
                var contract_file = JSON.parse(data.contract_file);
                if (contract_file.length > 0) {
                    for (var i = 0; i < contract_file.length; i++) {
                        var url = this.imgUrl + contract_file[i].file;
                        allContractUrls.push(url);
                    }
                }
            }
            this.allContractUrls = allContractUrls;
            this.dialogContractFormVisible = true;
        },
        // 跳转到特属服务对象详情
        goUserDetail(data) {
            this.$router.replace({
                name: "userDetail",
                params: {
                    user_id: data.user_id
                }
            });
        },
        // 聊天关系处理
        editChatRelation(data, type) {
            this.$confirm(`确定要解除与 "${data.user_name}" 的聊天关系吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'editChatRelation',
                    params: {
                        doctor_id: data.doctor_id,
                        user_id: data.user_id,
                        type: type,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                            duration: 1500,
                        });
                    } else {
                        this.$message({
                            type: "success",
                            message: '处理成功',
                            duration: 1500,
                        });
                    }
                    this.doctorUsersList();
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 到期状态修复
        resetExpired(data) {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'resetExpired',
                params: {
                    doctor_id: data.doctor_id,
                    user_id: data.user_id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                } else {
                    this.$message({
                        type: "success",
                        message: '到期状态修复成功',
                        duration: 1500,
                    });
                }
                this.doctorUsersList();
            });
        },

        userChangeSite(index) {
            this.user_perpage = index;
            this.doctorUsersList();
        },
        userChangePage(index) {
            this.user_page = index;
            this.doctorUsersList();
        },

        // 专家资料导出到word
        async importinfo() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let newDataArr = [];
            let user = [];
            let manager = [];
            let contracts = [];
            let type_name = '';
            let status_name = '';
            let _that = this;
            let user_name = this.user_name
            // 特属服务对象
            if (this.doctorUsers) {
                if (this.user_total > this.user_perpage) {
                    let start_date = '';
                    let end_date = '';

                    if (this.search_expired_date) {
                        start_date = this.search_expired_date[0]
                        end_date = this.search_expired_date[1]
                    }
                    let params = {
                        servername: 'Ruyi_AdminExpertServices',
                        method: 'doctorUsers',
                        params: {
                            user_id: this.user_id,
                            start_start_date: start_date,
                            end_start_date: end_date,
                        },
                        pageinfo: {
                            page: 1,
                            perpage: 100,
                        },
                    };
                    await this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }

                        for (let i = 0; i < res.data.data.list.length; i++) {
                            user.push({
                                name: res.data.data.list[i].user_name,
                                mobile: res.data.data.list[i].mobile,
                                start_date: res.data.data.list[i].start_date || '',
                                end_date: res.data.data.list[i].expired_date || '',
                                status: res.data.data.list[i].status == 1 ? "启用" : "停用",
                            })
                        }
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    });
                } else {
                    for (let i = 0; i < this.doctorUsers.length; i++) {
                        user.push({
                            name: this.doctorUsers[i].user_name,
                            mobile: this.doctorUsers[i].mobile,
                            start_date: this.doctorUsers[i].start_date,
                            end_date: this.doctorUsers[i].expired_date,
                            status: this.doctorUsers[i].status,
                        })
                    }
                }

            }

            // 健康管理助理
            if (this.manager_list) {
                for (let i = 0; i < this.manager_list.length; i++) {
                    manager.push({
                        name: this.manager_list[i].user_name,
                        mobile: this.manager_list[i].mobile,
                        company: this.manager_list[i].company_name,
                        department: this.manager_list[i].department_name,
                        group: this.manager_list[i].group_name,
                        title_name: this.manager_list[i].title_name || '',
                        status: this.manager_list[i].status == 1 ? '启用' : '停用',
                    })
                }
            }

            // 签约记录
            if (this.allContract) {
                for (let i = 0; i < this.allContract.length; i++) {
                    type_name = this.allContract[i].contract_type == 2 ? '续约' : '新约';
                    contracts.push({
                        status: this.allContract[i].status,
                        type: type_name,
                        start_date: this.allContract[i].start_date || '',
                        end_date: this.allContract[i].expired_date || '',
                    })
                }
            }

            newDataArr.push({
                "avatar": await getBase64Image(this.user_avatar),
                "user_name": this.user_name,
                "status": this.status == 1 ? '启用' : '停用',
                "title": this.doctor_title_name || ' ',
                "idcard": this.idcard || ' ',
                "hospital": this.hospital_nick_name || ' ',
                "department": this.hospital_department_name || ' ',
                "mobile": this.mobile || ' ',
                "expired_date": this.expired_date || ' ',
                "max_client": this.max_client || 0,
                "introduction": this.introduction || ' ',
                "client_user_num": this.clienting_number || 0,
                "history_user_num": this.log_client_number || 0,
                "reservation_num": this.reservationing_number || 0,
                "int_num": this.reservation_interrupt_number || 0,
                "succ_num": this.reservationed_number || 0,
                "user": user,
                "manager": manager,
                "contracts": contracts,
            })

            loadFile(
                "detail-doctor.docx",
                // "user.docx",
                function (error, content) {

                    if (error) {
                        this.is_submit = false;
                        throw error;
                    }

                    const zip = new PizZip(content);

                    let imageOpts = {}
                    imageOpts.centered = true;  // 图片居中，在word模板中定义方式为{%%image}
                    imageOpts.fileType = "docx";
                    imageOpts.getImage = function (newImgUrl) {
                        return base64Parser(newImgUrl);
                    }
                    imageOpts.getSize = function () {
                        return [190, 190]
                    }

                    const doc = new Docxtemplater(zip, {
                        paragraphLoop: true,
                        linebreaks: true,
                        modules: [new ImageModule(imageOpts)],
                    });

                    doc.render({
                        "doctor_info": newDataArr
                    });

                    const out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    // Output the document using Data-URI
                    saveAs(out, `特属专家资料-${user_name}.docx`);
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)

                }
            );

        },
        // 专家资料导出到word
        async importUserInfo() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let user = [];
            let _that = this;
            let user_name = this.user_name
            let start_date = '';
            let end_date = '';
            // 特属服务对象
            if (this.doctorUsers) {
                if (this.user_total > this.user_perpage) {
                    if (this.search_expired_date) {
                        start_date = this.search_expired_date[0]
                        end_date = this.search_expired_date[1]
                    }
                    let params = {
                        servername: 'Ruyi_AdminExpertServices',
                        method: 'doctorUsers',
                        params: {
                            user_id: this.user_id,
                            start_start_date: start_date,
                            end_start_date: end_date,
                        },
                        pageinfo: {
                            page: 1,
                            perpage: 100,
                        },
                    };
                    await this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }

                        for (let i = 0; i < res.data.data.list.length; i++) {
                            start_date = res.data.data.list[i].start_date.replaceAll('-', '/');
                            end_date = res.data.data.list[i].expired_date.replaceAll('-', '/');

                            user.push({
                                user_name: res.data.data.list[i].user_name,
                                mobile: res.data.data.list[i].mobile,
                                company: res.data.data.list[i].bloc_name,
                                posistion: res.data.data.list[i].posistion || '',
                                expired_date: start_date + '—' + end_date,
                            })
                        }
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    });
                } else {
                    for (let i = 0; i < this.doctorUsers.length; i++) {
                        start_date = this.doctorUsers[i].start_date.replaceAll('-', '/');
                        end_date = this.doctorUsers[i].expired_date.replaceAll('-', '/');

                        user.push({
                            user_name: this.doctorUsers[i].user_name,
                            mobile: this.doctorUsers[i].mobile,
                            company: this.doctorUsers[i].bloc_name,
                            posistion: this.doctorUsers[i].posistion || '',
                            expired_date: start_date + '—' + end_date,
                        })
                    }
                }

            }


            loadFile(
                "doctor-annex.docx",
                // "user.docx",
                function (error, content) {

                    if (error) {
                        this.is_submit = false;
                        throw error;
                    }

                    const zip = new PizZip(content);


                    const doc = new Docxtemplater(zip, {
                        paragraphLoop: true,
                        linebreaks: true,
                    });

                    doc.render({
                        "users": user,
                    });

                    const out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    // Output the document using Data-URI
                    saveAs(out, `${user_name}特属特属服务对象名单.docx`);
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)

                }
            );

        }
    },

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.docker-detail-header {
    text-align: right;
    margin: 20px 0 20px 0;

    .el-button {
        height: 32px;
        line-height: 6px;
    }
}

.table .dockert_img_td {
    width: 5% !important;
    min-width: 140px !important;
    padding-right: 10px;
    text-align: right;
    background-color: #f9fafd;
}

.table .docker_title_td {
    width: 10% !important;
    padding-right: 10px;
    text-align: right;
    background-color: #f9fafd;

}

.table .docker_value_td {
    width: 28% !important;
}

.message_box .message_title {
    text-align: left;
    font-size: 16px;
}

.message_box table {
    border-collapse: collapse !important;
    color: #606266;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
}

.message_box table tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
}

.message_box table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}

.message_box table tr:nth-child(1) {
    background-color: #f9fafd;
}

.message_box table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}

.message_box table tr > td:first-of-type {
    border-left: 0;
    border-bottom: 0;
}

.message_box table tr td {
    border-left: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
    font-size: 14px;
    padding: 15px 0 15px 10px;
    width: auto !important;
    text-align: center;
}

.table_message_box {
    margin: 50px 0px 20px 0px;
}

.search_data {
    float: right;
    margin: 15px 0px 15px 0px;
    width: 20%;
}

.image_box {
    height: 500px;
    overflow: hidden;
    overflow-y: auto;

    image {
        width: 100%;
    }
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}
</style>